module.exports = __webpack_public_path__ + "img/icon-agent.13a07b9c.png";